import {
  convertCubicMetersToCubicFeet,
  convertSquareMetersToSquareFeet,
} from "@/components/common/settings-context/distance-unit-utils";
import { humanReadableBytes } from "@faro-lotv/foundation";

/** Shown while the value is not known yet, so the panel keeps its layout */
export const PENDING_VALUE = "–";

/**
 * @param volume A volume in cubic meters
 * @returns the volume in cubic meters and feet
 */
export function formatVolume(volume: number): string {
  return `~${Math.round(volume).toLocaleString()} m\u00B3 (${Math.round(convertCubicMetersToCubicFeet(volume)).toLocaleString()} ft\u00B3)`;
}

/**
 * @param area An area in square meters
 * @returns the area in square meters and feet, so it reads the same for FARO and IPX
 */
export function formatFloorArea(area: number): string {
  const squareFeet = convertSquareMetersToSquareFeet(area);
  return `~${Math.round(area).toLocaleString()} m\u00B2 (${Math.round(squareFeet).toLocaleString()} ft\u00B2)`;
}

/**
 * @param bytes Size of the data in bytes
 * @param points Number of points, if known
 * @returns the size and the points in a compact form, e.g. "~923.6 MB (35.9M points)"
 */
export function formatDataSize(bytes: number, points?: number): string {
  const size = `~${humanReadableBytes(bytes, 1)}`;
  if (points === undefined) return size;
  const count = Intl.NumberFormat(undefined, {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(points);
  return `${size} (${count} points)`;
}
